import Vue from 'vue'
import VeeValidate from 'vee-validate'
import App from './App'
import router from './router'
import axios from 'axios'
import Buefy from 'buefy'
import ErrorModal from './components/ErrorModal'
import MessageModal from './components/MessageModal'
import * as constants from './constants'
import './filters.js'

import 'buefy/dist/buefy.css'
import 'font-awesome/css/font-awesome.css'

Vue.config.productionTip = false
Vue.use(Buefy)
Vue.use(VeeValidate)
Vue.config.devtools = true
Vue.prototype.$constants = constants

// Utility to add watchers for multiple props
Vue.prototype.$multiwatch = function (props, watcher) {
  const iterator = function (prop) {
    this.$watch(prop, watcher)
  }
  props.forEach(iterator, this)
}

axios.interceptors.response.use(
  function (response) {
    return response
  }, function (error) {
    if (error.response.status === 401 || error.response.status === 403) {
    // unauthorized - redirect to login
      router.push('/unauthorized')
      return Promise.reject(error)
    }
    if (error.config && Object.prototype.hasOwnProperty.call(error.config, 'manualErrorHandle') && error.config.manualErrorHandle === true) {
      return Promise.reject(error) // triggers the request's except block
    }
    // generic error
    if (mainVue) {
      mainVue.open_error_modal(error)
    }

    return Promise.reject(error)
  })

/* eslint-disable no-new */
const mainVue = new Vue({
  el: '#app',
  router,
  render: h => h(App),
  components: {
    ErrorModal,
    MessageModal
  },
  methods: {
    open_error_modal (error, raw = false) {
      this.$buefy.modal.open({
        parent: this,
        component: ErrorModal,
        hasModalCard: true,
        props: {
          error,
          raw
        }
      })
    },
    open_message_modal (message, raw = false) {
      this.$buefy.modal.open({
        parent: this,
        component: MessageModal,
        hasModalCard: true,
        props: {
          message,
          raw
        }
      })
    }
  }
})
